import { API_BASE_URL } from 'config/env-config';
import { getAccessToken } from 'utils/auth';
import { createFetchConfig } from 'utils/fetch-config';
import { apiCall } from './api-call';

export const createApiCall = <P = void, R = unknown>(
  action: string,
  configFn: (params: P) => {
    endpoint: string
    method: string
    body?: any
    streaming?: boolean
    skipDefaultErrorMessage?: boolean
    skipDefaultErrorHandling?: boolean
  }
) => {
  return apiCall(action, (params: P) => {
    const baseConfig = configFn(params);

    const {token} = getAccessToken()
    const fetchConfig = createFetchConfig(token);
   
    const fullEndpoint = `${API_BASE_URL}${baseConfig.endpoint.startsWith('/') ? baseConfig.endpoint : '/' + baseConfig.endpoint}`;

    const headers = { ...fetchConfig.headers };

    // Handle body based on type
    let processedBody = baseConfig.body;
    if (!(baseConfig.body instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
      // Only stringify if it's not already a string and not FormData
      if (typeof baseConfig.body !== 'string' && baseConfig.body !== null && baseConfig.body !== undefined) {
        processedBody = JSON.stringify(baseConfig.body);
      }
    }
    // For FormData, let the browser set the Content-Type with boundary

    return {
      ...baseConfig,
      endpoint: fullEndpoint,
      headers,
      body: processedBody
    };
  });
}